/* @flow */

import * as React from 'react'
import styled from 'styled-components'

import {
  ControlLabel,
  FormGroup,
  FormInput,
  RadioInput,
  SelectInput,
} from '../../../../../infrastructure/components/Formik'

import { DimensionsInput, SpacingSettings } from '../shared'

const WebshopCenteredContentSettings = ({ values }) => {
  return (
    <div>
      <FormGroup>
        <ControlLabel required>Center</ControlLabel>
        <RadioInput
          id="webshop-widget-centered-content-horizontally"
          name="data.center"
          label="Horizontally"
          value="horizontally"
        />
        <RadioInput
          id="webshop-widget-centered-content-vertically"
          name="data.center"
          label="Vertically"
          value="vertically"
        />
      </FormGroup>
      {values.data.center === 'horizontally' && (
        <FormGroup>
          <ControlLabel>Width</ControlLabel>

          <DimensionsInput
            modeName="data.width_mode"
            fixedName="data.fixed_width"
            parentPercentageName="data.parent_percentage_width"
            values={values}
          />
        </FormGroup>
      )}
      {values.data.center === 'vertically' && (
        <FormGroup>
          <ControlLabel>Height</ControlLabel>

          <DimensionsInput
            modeName="data.height_mode"
            fixedName="data.fixed_height"
            parentPercentageName="data.parent_percentage_height"
            values={values}
          />
        </FormGroup>
      )}

      <SpacingSettings />
    </div>
  )
}

export default WebshopCenteredContentSettings
